export enum TransactionAdminFilterKey {
  Status = 'status',
}

export const TRANSACTION_ADMIN_FILTER_KEYS = Object.values(TransactionAdminFilterKey);
